module.exports = __webpack_public_path__ + "img/warning.ee3ed2bd.png";